/* Product page: colour/size → variant, bundle tiers with a colour+size row per
   hoodie, free-shipping bar, AJAX add to bag, sticky mobile bar. */
(function () {
  'use strict';
  var root = document.querySelector('[data-product]');
  if (!root) return;
  var T = window.theme || {};
  var S = T.strings || {};
  var variants;
  try { variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch (e) { return; }

  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };
  var ci = +root.dataset.colourIndex, si = +root.dataset.sizeIndex;
  var form = document.getElementById('product-form');
  var addBtn = $('[data-add]'), errEl = $('[data-error]');
  var mainImg = $('.well__img'), thumbsEl = $('[data-thumbs]');
  var sticky = document.querySelector('[data-sticky]');
  var cartTotal = 0;
  var picksTouched = {};

  var money = T.formatMoney;

  function checked(name, el) { var i = $('input[name="' + name + '"]:checked', el); return i ? i.value : null; }
  function find(colour, size) {
    return variants.filter(function (v) {
      return (ci < 0 || v.options[ci] === colour) && (si < 0 || v.options[si] === size);
    })[0];
  }
  function tierInput() { return $('[data-tier]:checked'); }
  function qty() { var t = tierInput(); return t ? +t.value : +root.dataset.defaultQty || 1; }

  /* Every hoodie in the bag: row 1 is the main picker, rows 2–3 the mix & match picks. */
  function lines() {
    var out = [find(checked('colour'), checked('size'))];
    for (var i = 2; i <= qty(); i++) {
      var row = $('[data-pick="' + i + '"]');
      var sel = row && $('[data-pick-size]', row);
      out.push(find(row ? checked('pick' + i + '-colour', row) : checked('colour'), sel ? sel.value : checked('size')));
    }
    return out;
  }

  function prices() {
    var t = tierInput(), ls = lines(), v = ls[0];
    var unit = v ? v.price : 0, unitCompare = v ? Math.max(v.compare, v.price) : 0;
    var fixed = t ? +t.dataset.fixed : 0;
    var price = fixed || ls.reduce(function (s, l) { return s + (l ? l.price : 0); }, 0) || unit * qty();
    return { price: price, compare: unitCompare * qty() };
  }

  function setMain(btn) {
    if (!btn || !mainImg) return;
    mainImg.srcset = btn.dataset.srcset;
    mainImg.src = btn.dataset.src;
    if (btn.dataset.alt) mainImg.alt = btn.dataset.alt;
    $$('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', String(b === btn)); });
  }

  function syncDisabled() {
    var colour = checked('colour');
    $$('[data-size]').forEach(function (r) { var v = find(colour, r.value); r.disabled = !v || !v.available; });
    $$('[data-pick]').forEach(function (row) {
      var c = checked('pick' + row.dataset.pick + '-colour', row) || colour;
      $$('[data-pick-size] option', row).forEach(function (o) { var v = find(c, o.value); o.disabled = !v || !v.available; });
    });
  }

  function render() {
    var n = qty(), ls = lines(), v = ls[0], p = prices();
    var ok = ls.every(function (l) { return l && l.available; });

    // labels
    var cn = $('[data-colour-name]'), sn = $('[data-size-name]');
    if (cn) cn.textContent = checked('colour') || '';
    if (sn) sn.textContent = checked('size') || '';

    // price row
    $('[data-price]').textContent = money(p.price);
    var cmp = $('[data-compare]'), save = $('[data-save]');
    cmp.textContent = money(p.compare); cmp.hidden = p.compare <= p.price;
    save.textContent = (S.save || 'Save') + ' ' + money(p.compare - p.price); save.hidden = p.compare <= p.price;

    // mix & match rows
    var picks = $('[data-picks]');
    if (picks) {
      picks.hidden = n < 2;
      $$('[data-pick]').forEach(function (row) { row.hidden = +row.dataset.pick > n; });
    }

    // free shipping bar (existing bag + this selection)
    var bar = $('[data-ship]');
    if (bar && T.freeShipping) {
      var total = cartTotal + p.price, left = Math.max(0, T.freeShipping - total);
      $('[data-ship-msg]').textContent = left ? S.shipAway.replace('[amount]', money(left)) : S.shipDone;
      $('[data-ship-fill]').style.width = Math.min(100, total / T.freeShipping * 100) + '%';
    }

    // button + fallback form fields
    addBtn.disabled = !ok;
    addBtn.textContent = ok ? (S.addToBag + ' · ' + money(p.price)) : S.soldOut;
    if (v) $('[data-id-input]').value = v.id;
    $('[data-qty-input]').value = n;

    // sticky bar
    if (sticky) {
      var label = [checked('colour'), checked('size')].filter(Boolean).join(' · ');
      if (n > 1) label = n + ' hoodies · ' + label;
      sticky.querySelector('[data-sticky-label]').textContent = label;
      sticky.querySelector('[data-sticky-price]').textContent = money(p.price);
      var sb = sticky.querySelector('[data-sticky-add]');
      sb.disabled = !ok;
    }
    if (v && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  /* Colour change: put that colour's photo first and show it. Rows 2–3 follow
     hoodie 1 until the shopper changes them. */
  function onColour() {
    var c = checked('colour');
    var btn = thumbsEl && thumbsEl.querySelector('[data-colour="' + CSS.escape(c) + '"]');
    if (btn) { thumbsEl.insertBefore(btn, thumbsEl.firstChild); setMain(btn); }
    if (sticky && btn) { var si2 = sticky.querySelector('img'); if (si2) si2.src = btn.querySelector('img').src; }
    followMain();
  }
  function followMain() {
    $$('[data-pick]').forEach(function (row) {
      if (picksTouched[row.dataset.pick]) return;
      var r = $('input[value="' + CSS.escape(checked('colour') || '') + '"]', row);
      if (r) r.checked = true;
      var sel = $('[data-pick-size]', row);
      if (sel && checked('size')) sel.value = checked('size');
    });
  }

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-colour]')) onColour();
    else if (t.matches('[data-size]')) followMain();
    else if (t.closest('[data-pick]')) picksTouched[t.closest('[data-pick]').dataset.pick] = true;
    errEl.hidden = true;
    syncDisabled();
    render();
  });
  $$('[data-thumb]').forEach(function (b) { b.addEventListener('click', function () { setMain(b); }); });

  /* Add to bag */
  function add() {
    var ls = lines();
    if (!ls.every(function (l) { return l && l.available; })) return;
    var grouped = {};
    ls.forEach(function (l) { grouped[l.id] = (grouped[l.id] || 0) + 1; });
    var items = Object.keys(grouped).map(function (id) { return { id: +id, quantity: grouped[id] }; });
    addBtn.disabled = true;
    errEl.hidden = true;
    fetch(T.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return T.refreshCart(); })
      .then(function (cart) {
        cartTotal = cart.total_price;
        T.toast(S.added);
        document.dispatchEvent(new CustomEvent('cart:open', { detail: cart }));
      })
      .catch(function (err) {
        errEl.textContent = (err && (err.description || err.message)) || S.error;
        errEl.hidden = false;
      })
      .finally(render);
  }
  form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
  if (sticky) sticky.querySelector('[data-sticky-add]').addEventListener('click', add);

  /* Sticky bar: show once the main button has scrolled away above the viewport. */
  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', past);
      sticky.setAttribute('aria-hidden', String(!past));
      sticky.querySelector('[data-sticky-add]').tabIndex = past ? 0 : -1;
      document.body.style.paddingBottom = past && window.innerWidth < 900 ? sticky.offsetHeight + 'px' : '';
    }).observe(addBtn);
  }

  /* ?bundle=1|2|3 from the home page */
  var b = new URLSearchParams(window.location.search).get('bundle');
  var bi = b && $('[data-tier][value="' + parseInt(b, 10) + '"]');
  if (bi) bi.checked = true;

  syncDisabled();
  render();
  T.refreshCart().then(function (cart) { cartTotal = cart.total_price; render(); }).catch(function () {});
})();
